import Spinner from "@Atom/Spinner";
import Styles from "./styles.module.scss";
import Icon from "@Atom/Icon";
import { fileBaseUrl } from "@Config/api";
import Images from "@Theme/Images";
import moment from "moment";

export default function ProfileMenu({
  setEditPhotoProfile,
  inputPhotoProfileRef,
  handleSubmit,
  data,
  editPhotoProfile,
  loading,
  trigger,
  query,
  setEditInformationContact,
  setEditInformationPersonal,
  inputCvRef,
  inputOtherRef,
  setAddOtherFiles,
  inputEditOtherRef,
  setEditOtherFiles,
  setAddWorkExperience,
  setEditWorkExperience,
  setModalLinkVideo,
}) {
  const listTools = [
    {
      id: 1,
      desc: "Rekam video di tempat dengan pencahayaan yang baik dan suara yang jelas.",
    },
    {
      id: 2,
      desc: "Pastikan diri Anda berada di tengah frame dengan latar belakang yang rapi.",
    },
    {
      id: 3,
      desc: "Gunakan pakaian yang rapi dan sopan.",
    },
    {
      id: 4,
      desc: "Sebutkan nama, posisi, pengalaman kerja, dan alasan tertarik bekerja.",
    },
    {
      id: 5,
      desc: "Unggah video kamu melalui link Youtube, pastikan sebelumnya kamu telah menggunggah video pekenalan kamu di Youtube",
    },
  ];
  return (
    <div className={Styles.right}>
      <div className={Styles.profileBox}>
        <div
          className={Styles.images}
          onMouseEnter={() => {
            setEditPhotoProfile(true);
          }}
          onMouseLeave={() => {
            setEditPhotoProfile(false);
          }}
          onClick={() => inputPhotoProfileRef.current.click()}
        >
          <input
            accept="image/jpeg, image/png, image/jpg" // Mengizinkan JPG, JPEG, dan PNG
            type="file"
            ref={inputPhotoProfileRef}
            name="file"
            onChange={(e) => {
              if (e?.target?.files?.length > 0) {
                const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

                if (allowedTypes.includes(e?.target?.files[0].type)) {
                  handleSubmit(e, data, "PROFILE");
                }
              }
              e.target.value = "";
            }}
            hidden
          />
          {editPhotoProfile ||
          loading === "PROFILE" ||
          +trigger !== +query?.get("tr") ? (
            <div className={Styles.editBox}>
              {loading === "PROFILE" || +trigger !== +query?.get("tr") ? (
                <Spinner />
              ) : (
                <Icon icon={"edit"} color={"#FFFFFF"} size={24} />
              )}
            </div>
          ) : null}
          <img
            src={
              data?.profilePic
                ? data?.profilePic?.includes("https://")
                  ? data?.profilePic
                  : fileBaseUrl + data?.profilePic
                : Images.AVA_DEFAULT
            }
            alt=""
          />
        </div>
        <div className={Styles.name}>
          <span>{data?.name || "-"}</span>
        </div>
      </div>

      <div className={Styles.informationBox}>
        <div className={Styles.headerInfo}>
          <span className={Styles.leftInfo}>
            <span>Informasi Kontak</span>

            {!data?.email || !data?.phoneNumber ? (
              <div>
                <Icon icon={"information-solid"} size={20} color={"#F28609"} />
                <span>Lengkapi data diri kamu sekarang!</span>
              </div>
            ) : null}
          </span>
        </div>

        <div className={Styles.info}>
          <div>
            <div className={Styles.listInfo}>
              <div className={Styles.icon}>
                <Icon icon={"email-outline"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.titleInfo}>
                <div>
                  <span>
                    Email{" "}
                    <div
                      onClick={() => {
                        setEditInformationContact("email");
                      }}
                    >
                      <Icon icon={"edit"} size={16} color={"#1571DE"} />
                    </div>
                  </span>

                  {!data?.isEmailVerify && (
                    <div>
                      <Icon
                        icon={"information-solid"}
                        size={16}
                        color={"#FF3E13"}
                      />
                      <span>Belum terverifikasi</span>
                    </div>
                  )}
                </div>

                <span>{data?.email || "-"}</span>
              </div>
            </div>

            {!data?.isEmailVerify && (
              <div className={Styles.button}>
                <button
                  disabled={loading === "email"}
                  onClick={(e) => {
                    handleSubmit(e, data?.email, "email");
                  }}
                >
                  {loading === "email" ? <Spinner /> : "Verifikasi Email"}
                </button>
              </div>
            )}
          </div>
          <div>
            <div className={Styles.listInfo}>
              <div className={Styles.icon}>
                <Icon icon={"whatsapp"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.titleInfo}>
                <div>
                  <span>
                    Nomor Whatsapp{" "}
                    <div
                      onClick={() => {
                        setEditInformationContact("phoneNumber");
                      }}
                    >
                      <Icon icon={"edit"} size={16} color={"#1571DE"} />
                    </div>
                  </span>

                  {!data?.isPhoneNumberVerify && (
                    <div>
                      <Icon
                        icon={"information-solid"}
                        size={16}
                        color={"#FF3E13"}
                      />
                      <span>Belum terverifikasi</span>
                    </div>
                  )}
                </div>

                {data?.phoneNumber ? (
                  <span>+{data?.phoneNumber || "-"}</span>
                ) : (
                  <span>Belum ada nomor terdaftar</span>
                )}
              </div>
            </div>
            {!data?.isPhoneNumberVerify && data?.phoneNumber && (
              <div className={Styles.button}>
                <button
                  disabled={loading === "phoneNumber"}
                  onClick={(e) => {
                    handleSubmit(e, data?.phoneNumber, "phoneNumber");
                  }}
                >
                  {loading === "phoneNumber" ? <Spinner /> : "Verifikasi Nomor"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={Styles.informationPersonalBox}>
        <div className={Styles.headerInfo}>
          <div className={Styles.leftInfo}>
            <span>Informasi personal</span>
            {!data?.idNumber ||
            !data?.dateOfBirth ||
            !data?.gender ||
            data?.CandidateAccountEducations?.length === 0 ||
            data?.CandidateAccountSkills?.length === 0 ||
            (data?.CandidateAccountSkills?.length > 0 &&
              !data?.CandidateAccountSkills?.find(
                (el) => el?.skill === "Kemampuan Bahasa Inggris"
              )?.level) ||
            !data?.domicile ||
            !data?.address ? (
              <div>
                <Icon icon={"information-solid"} size={20} color={"#F28609"} />
                <span>Lengkapi data diri kamu sekarang!</span>
              </div>
            ) : null}
          </div>

          <div
            className={Styles.rightInfo}
            onClick={() => {
              setEditInformationPersonal(true);
            }}
          >
            <div className={Styles.icon}>
              <Icon icon={"edit"} size={20} color={"#1571DE"} />
            </div>
            <span>Ubah Data</span>
          </div>
        </div>

        <div className={Styles.contentInfo}>
          <div className={Styles.listBox}>
            <div className={Styles.list}>
              <div className={Styles.icon}>
                <Icon icon={"nik"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.desc}>
                <span>NIK</span>
                <span>{data?.idNumber || "-"}</span>
              </div>
            </div>

            <div className={Styles.list}>
              <div className={Styles.icon}>
                <Icon icon={"calender-outline"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.desc}>
                <span>Tanggal Lahir</span>
                <span>
                  {data?.dateOfBirth
                    ? moment(new Date(data?.dateOfBirth))?.format(
                        "DD MMMM YYYY"
                      )
                    : ""}
                </span>
              </div>
            </div>
          </div>

          <div className={Styles.listBox}>
            <div className={Styles.list}>
              <div className={Styles.icon}>
                <Icon icon={"gender"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.desc}>
                <span>Jenis Kelamin</span>
                <span>{data?.gender || "-"}</span>
              </div>
            </div>

            <div className={Styles.list}>
              <div className={Styles.icon}>
                <Icon icon={"graduation"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.desc}>
                <span>Pendidikan Terakhir</span>
                <span>
                  {data?.CandidateAccountEducations?.length > 0
                    ? data?.CandidateAccountEducations[0]?.level
                    : "-"}
                </span>
              </div>
            </div>
          </div>

          <div className={Styles.listBox}>
            <div className={Styles.list}>
              <div className={Styles.icon}>
                <Icon icon={"language"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.desc}>
                <span>Kemampuan Bahasa Inggris</span>
                <span>
                  {data?.CandidateAccountSkills?.length
                    ? data?.CandidateAccountSkills?.find(
                        (el) => el?.skill === "Kemampuan Bahasa Inggris"
                      )?.level || "-"
                    : "-"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Styles.contentInfo} ${Styles.noBorder}`}>
          <div className={Styles.listBox}>
            <div className={Styles.list}>
              <div className={Styles.icon}>
                <Icon icon={"location-profile"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.desc}>
                <span>Domisili (Tempat Tinggal Sekarang)</span>
                <span>{data?.domicile || "-"}</span>
              </div>
            </div>

            <div className={Styles.list}>
              <div className={Styles.icon}>
                <Icon icon={"location-point"} size={24} color={"#1571DE"} />
              </div>

              <div className={Styles.desc}>
                <span>Alamat Lengkap</span>
                <span>{data?.address || "-"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={Styles.informationPersonalBox}>
        <div className={Styles.headerInfo}>
          <div className={Styles.leftInfo}>
            <span>Video Perkenalan Diri</span>
            {data?.CandidateAccountDocuments?.length === 0 ||
            (data?.CandidateAccountDocuments?.length > 0 &&
              !data?.CandidateAccountDocuments?.find(
                (el) => el?.label?.toLowerCase() === "video"
              )?.url) ? (
              <div>
                <Icon icon={"information-solid"} size={20} color={"#F28609"} />
                <span>Video perkenalan belum diunggah</span>
              </div>
            ) : null}
          </div>
        </div>

        <div className={Styles.descVideo}>
          <span className={Styles.span1}>
            Buat video perkenalan diri kamu, biar kamu lebih dikenal oleh
            rekruter! Silahkan baca arahan dibawah ini:
          </span>

          <div className={Styles.listTools}>
            {listTools?.map((el, idx) => {
              return (
                <div key={idx}>
                  <div className={Styles.bullet}></div>
                  <span>{el?.desc || "-"}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className={Styles.cvBox}>
          <div className={Styles.leftCv}>
            <div className={Styles.icon}>
              <Icon icon={"video-outline"} size={24} color={"#1571DE"} />
            </div>

            <span
              className={`${
                data?.CandidateAccountDocuments?.length > 0 &&
                data?.CandidateAccountDocuments?.find(
                  (el) => el?.label?.toLowerCase() === "video"
                )?.url &&
                Styles.blue
              }`}
              onClick={() => {
                if (
                  data?.CandidateAccountDocuments?.length > 0 &&
                  data?.CandidateAccountDocuments?.find(
                    (el) => el?.label?.toLowerCase() === "video"
                  )?.url
                ) {
                  window.open(
                    data?.CandidateAccountDocuments?.find(
                      (el) => el?.label?.toLowerCase() === "video"
                    )?.url
                  );
                }
              }}
            >
              {data?.CandidateAccountDocuments?.length > 0
                ? data?.CandidateAccountDocuments?.find(
                    (el) => el?.label?.toLowerCase() === "video"
                  )?.url || "Belum ada video yang ditambahkan"
                : "Belum ada video yang ditambahkan"}
            </span>
          </div>

          <div className={Styles.rightCv}>
            <button onClick={() => setModalLinkVideo(true)}>
              <Icon
                icon={
                  data?.CandidateAccountDocuments?.length > 0 &&
                  data?.CandidateAccountDocuments?.find(
                    (el) => el?.label?.toLowerCase() === "video"
                  )?.url
                    ? "return"
                    : "upload"
                }
                size={20}
                className={Styles.iconUUpload}
              />
              {data?.CandidateAccountDocuments?.length > 0 &&
              data?.CandidateAccountDocuments?.find(
                (el) => el?.label?.toLowerCase() === "video"
              )?.url
                ? "Perbaharui"
                : "Masukan Link"}
            </button>
          </div>
        </div>
      </div>

      <div className={Styles.informationPersonalBox}>
        <div className={Styles.headerInfo}>
          <div className={Styles.leftInfo}>
            <span>CV</span>
            {data?.CandidateAccountDocuments?.length === 0 ||
            (data?.CandidateAccountDocuments?.length > 0 &&
              !data?.CandidateAccountDocuments?.find((el) => el?.label === "CV")
                ?.url) ? (
              <div>
                <Icon icon={"information-solid"} size={20} color={"#F28609"} />
                <span>CV belum diunggah</span>
              </div>
            ) : null}
          </div>

          {data?.CandidateAccountDocuments?.length > 0 &&
            data?.CandidateAccountDocuments?.find(
              (el) => el?.label === "CV"
            ) && (
              <div className={Styles.dateInfo}>
                Diunggah pada{" "}
                {data?.CandidateAccountDocuments?.find(
                  (el) => el?.label === "CV"
                )?.createdAt
                  ? moment(
                      new Date(
                        data?.CandidateAccountDocuments?.find(
                          (el) => el?.label === "CV"
                        )?.createdAt
                      )
                    ).format("DD MMMM YYYY")
                  : "-"}
              </div>
            )}
        </div>

        <div className={Styles.cvBox}>
          <div className={Styles.leftCv}>
            <div className={Styles.icon}>
              <Icon icon={"report"} size={24} color={"#1571DE"} />
            </div>
            <span>
              {data?.CandidateAccountDocuments?.length > 0
                ? data?.CandidateAccountDocuments?.find(
                    (el) => el?.label === "CV"
                  )?.url || "Belum ada CV diunggah"
                : "Belum ada CV diunggah"}
            </span>
          </div>

          <div className={Styles.rightCv}>
            <button
              disabled={loading === "CV" || +trigger !== +query?.get("tr")}
              onClick={() => inputCvRef.current.click()}
            >
              <Icon
                icon={
                  data?.CandidateAccountDocuments?.length > 0 &&
                  data?.CandidateAccountDocuments?.find(
                    (el) => el?.label === "CV"
                  )?.url
                    ? "return"
                    : "upload"
                }
                size={20}
                className={Styles.iconUUpload}
              />
              {loading === "CV" || +trigger !== +query?.get("tr")
                ? "Loading..."
                : data?.CandidateAccountDocuments?.length > 0 &&
                  data?.CandidateAccountDocuments?.find(
                    (el) => el?.label === "CV"
                  )?.url
                ? "Perbaharui CV"
                : " Unggah CV"}

              <input
                accept="application/pdf" // Membatasi hanya file PDF
                type="file"
                ref={inputCvRef}
                name="file"
                onChange={(e) => {
                  if (e?.target?.files?.length > 0) {
                    if (e?.target?.files?.[0]?.type === "application/pdf") {
                      handleSubmit(e, data, "CV");
                    }
                  }
                  e.target.value = "";
                }}
                hidden
              />
            </button>
          </div>
        </div>
      </div>

      <div className={Styles.informationPersonalBox}>
        <div className={Styles.headerInfo}>
          <div className={Styles.leftInfo}>
            <span>Dokumen Lainnya</span>
          </div>
          {data?.CandidateAccountDocuments?.length > 0 &&
            data?.CandidateAccountDocuments?.filter(
              (item) =>
                item?.label !== "CV" && item?.label?.toLowerCase() !== "video"
            )?.length > 0 && (
              <div
                className={Styles.rightInfo}
                style={{
                  width: "250px",
                }}
                onClick={() => inputOtherRef.current.click()}
              >
                <div className={Styles.icon}>
                  <Icon icon={"circle-plus"} size={20} color={"#1571DE"} />
                </div>
                <span>Tambah Dokumen</span>
                <input
                  accept="application/pdf" // Membatasi hanya file PDF
                  type="file"
                  ref={inputOtherRef}
                  name="file"
                  onChange={(e) => {
                    if (e?.target?.files?.length > 0) {
                      if (e?.target?.files?.[0]?.type === "application/pdf") {
                        setAddOtherFiles(e?.target?.files?.[0]);
                      }
                    }

                    e.target.value = "";
                  }}
                  hidden
                />
              </div>
            )}
        </div>

        {data?.CandidateAccountDocuments?.length > 0 &&
        data?.CandidateAccountDocuments?.filter(
          (item) =>
            item?.label !== "CV" && item?.label?.toLowerCase() !== "video"
        )?.length > 0 ? (
          <div className={Styles.otherDoc}>
            {data?.CandidateAccountDocuments?.filter(
              (item) =>
                item?.label !== "CV" && item?.label?.toLowerCase() !== "video"
            )?.map((el, idx) => {
              return (
                <div className={Styles.doc} key={idx}>
                  <span>{el?.label || "-"}</span>
                  <div>
                    <div className={Styles.leftDoc}>
                      <div className={Styles.icon}>
                        <Icon icon={"file"} size={24} color={"#1571DE"} />
                      </div>
                      <span>{el?.url || "-"}</span>
                    </div>

                    <div className={Styles.rightDoc}>
                      <div>
                        <Icon
                          icon={"edit"}
                          size={24}
                          color={"#1571DE"}
                          onClick={() => inputEditOtherRef?.current?.click()}
                        />
                        <input
                          key={Math.random()} // Key dinamis untuk mereset elemen input
                          accept="application/pdf"
                          type="file"
                          ref={inputEditOtherRef}
                          name="file"
                          onChange={(e) => {
                            if (e?.target?.files?.length > 0) {
                              if (
                                e?.target?.files?.[0]?.type ===
                                "application/pdf"
                              ) {
                                setEditOtherFiles({
                                  data: el,
                                  file: e?.target?.files?.[0],
                                });
                              }
                            }
                            e.target.value = "";
                          }}
                          hidden
                        />
                      </div>

                      <div>
                        {loading === el?.id ||
                        +trigger !== +query?.get("tr") ? (
                          <Spinner />
                        ) : (
                          <Icon
                            icon={"delete"}
                            size={24}
                            color={"#FF3E13"}
                            onClick={(e) => {
                              if (!loading) {
                                handleSubmit(e, el, "Otherdocument");
                              }
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={Styles.emptyDoc}>
            <span>Belum ada dokumen lain yang ditambahkan</span>
            <div>
              <button onClick={() => inputOtherRef.current.click()}>
                <Icon
                  icon={"circle-plus"}
                  size={20}
                  className={Styles.iconUUpload}
                />
                Tambah dokumen lainnya
                <input
                  accept="application/pdf" // Membatasi hanya file PDF
                  type="file"
                  ref={inputOtherRef}
                  name="file"
                  onChange={(e) => {
                    if (e?.target?.files?.length > 0) {
                      if (e?.target?.files?.[0]?.type === "application/pdf") {
                        setAddOtherFiles(e?.target?.files?.[0]);
                      }
                    }

                    e.target.value = "";
                  }}
                  hidden
                />
              </button>
            </div>
          </div>
        )}
      </div>

      <div className={Styles.informationPersonalBox}>
        <div className={Styles.headerInfo}>
          <div className={Styles.leftInfo}>
            <span>Pengalaman Bekerja</span>
          </div>
          {data?.CandidateAccountWorkExperiences?.length > 0 && (
            <div
              onClick={() => {
                setAddWorkExperience(true);
              }}
              className={Styles.rightInfo}
              style={{
                width: "250px",
              }}
            >
              <div className={Styles.icon}>
                <Icon icon={"circle-plus"} size={20} color={"#1571DE"} />
              </div>
              <span>Tambah Pengalaman</span>
            </div>
          )}
        </div>

        {data?.CandidateAccountWorkExperiences?.length > 0 ? (
          <div className={Styles.otherDoc}>
            {data?.CandidateAccountWorkExperiences?.map((el, idx) => {
              return (
                <div className={Styles.doc} key={idx}>
                  <div>
                    <div className={Styles.descExperiences}>
                      <span>{el?.jobTitle || "-"}</span>
                      <div>
                        <Icon icon={"building"} color={"#0A0A0A"} size={18} />
                        <span>{el?.companyName || "-"}</span> •{" "}
                        <Icon
                          icon={"calendar-v2"}
                          color={"#0A0A0A"}
                          size={18}
                        />
                        {`${el?.startMonth || "-"} ${el?.startYear || "-"}`} -{" "}
                        {el?.isEmployed
                          ? "Saat ini"
                          : `${el?.endMonth} ${el?.endYear}`}
                      </div>
                    </div>

                    <div className={Styles.rightDoc}>
                      <div>
                        <Icon
                          icon={"edit"}
                          size={24}
                          color={"#1571DE"}
                          onClick={() => {
                            setEditWorkExperience(el);
                          }}
                        />
                      </div>
                      {loading === el?.id || +trigger !== +query?.get("tr") ? (
                        <Spinner />
                      ) : (
                        <div>
                          <Icon
                            icon={"delete"}
                            size={24}
                            color={"#FF3E13"}
                            onClick={(e) => {
                              if (!loading) {
                                handleSubmit(e, el, "experiences");
                              }
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={Styles.emptyDoc}>
            <span>Belum ada pengalaman pekerjaan yang ditambahkan</span>
            <div>
              <button
                onClick={() => {
                  setAddWorkExperience(true);
                }}
              >
                <Icon
                  icon={"bag-profile"}
                  size={20}
                  className={Styles.iconUUpload}
                />
                Tambah Pengalaman
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
